// extracted by mini-css-extract-plugin
module.exports = {"AuditLog":"styles_AuditLog__1mQb6"};